<template>
  <tr>
    <template v-if="gameId === 0">
      <td>{{ item.round_id }}</td>
      <td>{{ item.created_at }}</td>
      <td>{{ item.sector_value?.value }}</td>
      <td>{{ item?.value }}</td>
      <td>{{ item.factor }}</td>
      <td>{{ item.prize }}</td>
    </template>
    <template v-else-if="gameId === 1">
      <td>{{ item.game_id }}</td>
      <td>{{ item.created_at }}</td>
      <td>{{ item.orientation }}</td>
      <td>{{ item.rate }}</td>
      <td>{{ item.bet }}</td>
      <td>{{ item.result }}</td>
      <td>{{ item.factor }}</td>
      <td>{{ item.prize }}</td>
    </template>
    <template v-else-if="gameId === 2">
      <td>{{ item.game_id }}</td>
      <td>{{ item.created_at }}</td>
      <td>{{ item.bet }}</td>
      <td>{{ item.opened_cells }}</td>
      <td>{{ item.mines_count }}</td>
      <td>{{ item.factor }}</td>
      <td>{{ item.prize }}</td>
    </template>
    <template v-else-if="gameId === 3">
      <td>{{ item.round_id }}</td>
      <td>{{ item.created_at }}</td>
      <td>{{ item?.value }}</td>
      <td>{{ item.factor }}</td>
      <td>{{ item.auto_take }}</td>
      <td>{{ item.prize }}</td>
      <td>{{ item.result }}</td>
    </template>
    <template v-else-if="gameId === 4">
      <td>{{ item.game_id }}</td>
      <td>{{ item.created_at }}</td>
      <td>{{ item.bet }}</td>
      <td>{{ item.opened_cells }}</td>
      <td>{{ item.difficult ? 'High' : 'Low' }}</td>
      <td>{{ item.factor }}</td>
      <td>{{ item.prize }}</td>
    </template>
  </tr>
</template>

<script>
export default {
  name: 'BetItem',
  props: {
    gameId: Number,
    item: {
      id: 0,
      time_start: '',
      value: 0,
      factor: 0,
      prize: 0
    }
  }
}
</script>

<style scoped>

</style>
